import styled from "styled-components"

export const QRCodeContainer = styled.div`
  height: 350px;
  width: 350px;
  margin: 0 auto 32px;
`

export const Container = styled.div``